import React, { useEffect, useState } from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { MakePayment } from '../components/screens';
import { MerchantServiceCategory } from '../api';
import { titleCase } from '../util';

function PageWithLayout({ user, logout }) {
  const [merchantServiceCategories, setMerchantServiceCategories] = useState();
  const [loadCategoriesError, setLoadCategoriesError] = useState();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const result = await MerchantServiceCategory.getAll();
        console.log("result::", result);
        const activeMerchantServiceCategories = result.filter(item => item.status === "ACTIVE");

        let merchantServiceCategories = [];
        let loadCategoriesError = '';

        if (result instanceof Error) {
          loadCategoriesError = result.message;
        } else {
          merchantServiceCategories = activeMerchantServiceCategories.map((item) => {
              const { type } = item;
              const withoutHypens = type.replace('-', ' ');
              return {
                ...item,
                name: titleCase(withoutHypens),
                type: type.toLowerCase(),
                rank: parseInt(item.rank),
              };
            })
            .sort(function compare(one, other) {
              // sort by rank
              if (one.rank < other.rank) return -1;
              if (one.rank > other.rank) return 1;
              return 0;
            });
        }

        


        setMerchantServiceCategories(merchantServiceCategories);
        setLoadCategoriesError(loadCategoriesError);
        setReady(true);
      } catch (e) {
        console.error('error -> ', e);
        // show hte login modal here.
      }
    })()
  }, [])
  if (!ready) return null;

  
  return (
    <WebsiteLayout user={user} handleLogout={logout}>
      <MakePayment
        handleLogout={logout}
        merchantServiceCategories={merchantServiceCategories}
        loadCategoriesError={loadCategoriesError}
      />
    </WebsiteLayout>
  );
}

// PageWithLayout.getInitialProps = async (context) => {
//   try {
//     const result = await MerchantServiceCategory.getAll();

//     let merchantServiceCategories = [];
//     let loadCategoriesError = '';

//     if (result instanceof Error) {
//       loadCategoriesError = result.message;
//     } else {
//       merchantServiceCategories = result
//         .map((item) => {
//           const { type } = item;
//           const withoutHypens = type.replace('-', ' ');
//           return {
//             ...item,
//             name: titleCase(withoutHypens),
//             type: type.toLowerCase(),
//             rank: parseInt(item.rank),
//           };
//         })
//         .sort(function compare(one, other) {
//           // sort by rank
//           if (one.rank < other.rank) return -1;
//           if (one.rank > other.rank) return 1;
//           return 0;
//         });
//     }

//     return {
//       merchantServiceCategories,
//       loadCategoriesError,
//     };
//   } catch (e) {
//     console.error('error -> ', e);
//     // show hte login modal here.
//   }
// };

export default PageWithLayout;
